<script setup>
// @ts-check

import UnassignedBankTransaction from '@/components/UnassignedBankTransaction.vue'
import { useArrayFilter } from '@vueuse/core'
import { toRefs } from 'vue'

const props = defineProps({
  transactions: {
    /** @type {import('vue').PropType<BankTransactions>} */
    type: Array,
    required: true
  },
  selectedBankTransactions: {
    /** @type {import('vue').PropType<BankTransactions>} */
    type: Array,
    default: () => []
  },
  totalAmount: {
    type: Number,
    default: null
  },
  checkboxesDisabled: {
    type: Boolean
  }
})

const emit = defineEmits(['select'])

const { transactions, totalAmount } = toRefs(props)

const priorityTransactions = useArrayFilter(
  transactions,
  (transaction) => Math.abs(transaction.amount) === Math.abs(totalAmount.value)
)

const otherTransactions = useArrayFilter(
  transactions,
  (transaction) => Math.abs(transaction.amount) !== Math.abs(totalAmount.value)
)
</script>

<template>
  <tbody v-if="priorityTransactions.length">
    <tr class="border-none">
      <td colspan="4" class="pt-4 pb-2">
        <div class="flex w-full flex-row items-center justify-start">
          <h3 class="pr-3 font-primary text-xs font-medium">
            {{ $t('bank_transactions.table.events_by_amount') }}
          </h3>
          <hr class="grow border-b border-secondary-300" />
        </div>
      </td>
    </tr>
    <UnassignedBankTransaction
      v-for="transaction in priorityTransactions"
      :key="`priority-${transaction.id}`"
      :transaction
      :disabled="checkboxesDisabled"
      :model-value="
        selectedBankTransactions.some(({ id }) => transaction.id === id)
      "
      @update:model-value="
        emit('select', { transaction: { ...transaction }, isSelected: $event })
      "
    />
  </tbody>
  <tbody v-if="otherTransactions.length">
    <tr class="border-none">
      <td colspan="4" class="pt-4 pb-2">
        <div class="flex w-full flex-row items-center justify-start">
          <h3 class="pr-3 font-primary text-xs font-medium">
            {{ $t('bank_transactions.table.event_history') }}
          </h3>
          <hr class="grow border-b border-secondary-300" />
        </div>
      </td>
    </tr>
    <UnassignedBankTransaction
      v-for="transaction in otherTransactions"
      :key="`other-${transaction.id}`"
      :transaction
      :disabled="checkboxesDisabled"
      :model-value="
        selectedBankTransactions.some(({ id }) => transaction.id === id)
      "
      @update:model-value="
        emit('select', { transaction: { ...transaction }, isSelected: $event })
      "
    />
  </tbody>
</template>
